import React, { useEffect } from "react";
import ReactTypingEffect from "react-typing-effect";
import { Link } from "react-router-dom";
import pp from "../../assets/imgs/pp.jpg";
import { toTop } from "../../services/commonFunctions";
import socialIcons from "../../configs/socialConfig";
import SocialMediaIcon from "../../components/shared/SocialMediaIcon";

/**
 * HomePage Component
 */
const HomePage = () => {
  useEffect(() => {
    toTop();
  }, []);

  return (
    <div id="home" className="container-fluid align-items-center">
      <div className="row align-items-center h-100">
        <div className="col-lg-4 text-center">
          <img className="img-fluid mb-3" src={pp} alt="Youssef Zidan" />
        </div>
        <div className="offset-lg-1 col-lg-5">
          <div className="text-white text-center">
            <h1 className="display-3 font-weight-bold">
              <span className="text-primary">Youssef Zidan</span>
            </h1>
            <h3 className="text-white">
              <ReactTypingEffect
                text={["Web Developer", "UI/UX Designer", "Freelancer", "Instructor"]}
                speed="90"
                eraseSpeed="90"
                typingDelay="100"
                eraseDelay="2000"
              />
            </h3>
            <button
              type="button"
              className="mt-4 mb-5 px-6 btn btn-lg btn-primary border-pill font-weight-bold rounded-pill"
            >
              <Link to="/about" className="text-dark">
                MORE ABOUT ME
              </Link>
            </button>
            <div className="d-flex justify-content-around w-fit m-auto text-primary">
              {socialIcons.map((icon) => (
                <React.Fragment key={icon.href}>
                  <SocialMediaIcon icon={icon} />
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
